export default __webpack_public_path__ + "static/download_pdf-c9140af3840e845cc8e4195a107365d5.png";